import secureLocalStorage from "react-secure-storage";
import { formatNumber } from "@telerik/kendo-intl";
import * as React from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
export default class RiskFrequencyComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      temp:this.props.dataItem[this.props.field]
    };
  }
  componentDidMount = () => {
    if(this.props.dataItem.inEdit&&document.getElementById("probabilityid")){
        document.getElementById("probabilityid").focus();
    }
  };
  handleChange = (e) => {
    this.setState({ temp: e.value });
  };
  handleBlur = (e) => {
    this.props.handleCellAddValue(this.state.temp);
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: this.state.temp,
    });
    if (
      this.props.field &&
      this.props.field === this.props.dataItem.inEdit &&
      this.props.dataItem.riskRegisterId
    ) {
      let updateData = {
        ...this.props.dataItem,
        frequency: this.state.temp,
      };
      if (this.state.temp != this.props.dataItem.frequency) {
        this.props.updateDropdownValue(updateData);
      }
    }
  };
  handleEditCell = () => {
    if (this.props.dataItem.riskRegisterId) {
    this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  };
  handleChangeForAdd = (e) => {
    this.props.handleCellAddValue(e.value);
  };
  render() {
    const { dataItem, field } = this.props;
    const loginUserId=parseInt(secureLocalStorage.getItem("loginUserId"));
 const ownerId=dataItem.userId;
    const dataValue =
      dataItem[field] === null || dataItem[field] == undefined
        ? ""
        : dataItem[field];
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td>
          {this.props.riskAddOrEdit == true ? (
            <NumericTextBox
              defaultValue={dataValue}
              onChange={(e) => this.handleChangeForAdd(e)}
              min={0}
              max={100}
              id="probabilityid"
            />
          ) : (
            <NumericTextBox
              defaultValue={dataValue}
              onChange={(e) => this.handleChange(e)}
              onBlur={this.handleBlur}
              min={0}
              max={100}
              id="probabilityid"
            />
          )}
        </td>
      );
    } else {
      if(loginUserId===ownerId){
        return (
        <td onClick={this.handleEditCell}>{formatNumber(dataValue, "##,#")}</td>
        )
      }else{
      return this.props.dataItem.role == "Standard User" ||
      this.props.dataItem.role == "View Only" ? (
        <td>{formatNumber(dataValue, "##,#")}</td>
      ) : (
        <td onClick={this.handleEditCell}>{formatNumber(dataValue, "##,#")}</td>
      );
      }
    }
  }
}
